export interface RecentActivity {
  id: number;
  type: 'appointment_new' | 'appointment_done' | 'appointment_cancel' | 'payment_cash' | 'payment_card' | 'payment_transfer' | 'package_used' | 'package_bought' | 'expense' | 'customer_new';
  title: string;
  description: string;
  time: string;
  amount?: string;
  icon: string;
  iconBg: string;
  iconColor: string;
}

export const recentActivities: RecentActivity[] = [
  {
    id: 1,
    type: 'appointment_done',
    title: 'Ayşe Demir',
    description: 'Masaj Seansı tamamlandı',
    time: '14:30',
    amount: '₺450',
    icon: 'ri-check-double-line',
    iconBg: 'rgba(16,185,129,0.12)',
    iconColor: '#10B981',
  },
  {
    id: 2,
    type: 'payment_cash',
    title: 'Nakit Tahsilat',
    description: 'Ahmet Yılmaz — Masaj + Cilt Bakımı',
    time: '14:15',
    amount: '₺780',
    icon: 'ri-money-cny-circle-line',
    iconBg: 'rgba(16,185,129,0.12)',
    iconColor: '#10B981',
  },
  {
    id: 3,
    type: 'appointment_new',
    title: 'Yeni Randevu',
    description: 'Fatma Kaya — SPA Paket, 18 Mayıs 16:00',
    time: '13:50',
    icon: 'ri-calendar-check-line',
    iconBg: 'rgba(59,130,246,0.12)',
    iconColor: '#3B82F6',
  },
  {
    id: 4,
    type: 'package_used',
    title: 'Paket Seansı Kullanıldı',
    description: 'Zeynep Şahin — SPA Paket (3/5 kaldı)',
    time: '13:20',
    icon: 'ri-vip-crown-line',
    iconBg: 'rgba(139,92,246,0.12)',
    iconColor: '#8B5CF6',
  },
  {
    id: 5,
    type: 'payment_card',
    title: 'Kredi Kartı Tahsilat',
    description: 'Mehmet Kaya — Masaj Seansı',
    time: '12:45',
    amount: '₺380',
    icon: 'ri-bank-card-line',
    iconBg: 'rgba(201,169,98,0.12)',
    iconColor: '#C9A962',
  },
  {
    id: 6,
    type: 'appointment_cancel',
    title: 'Randevu İptali',
    description: 'Hakan Mert — Cilt Bakımı, saat 16:00',
    time: '12:10',
    icon: 'ri-close-circle-line',
    iconBg: 'rgba(239,68,68,0.12)',
    iconColor: '#EF4444',
  },
  {
    id: 7,
    type: 'expense',
    title: 'Gider Kaydı',
    description: 'Temizlik malzemesi alımı — Etiler Plaza',
    time: '11:30',
    amount: '₺420',
    icon: 'ri-shopping-cart-line',
    iconBg: 'rgba(239,68,68,0.12)',
    iconColor: '#EF4444',
  },
  {
    id: 8,
    type: 'customer_new',
    title: 'Yeni Müşteri',
    description: 'Elif Yıldız kaydedildi — Meta kaynağı',
    time: '11:00',
    icon: 'ri-user-add-line',
    iconBg: 'rgba(45,95,62,0.12)',
    iconColor: '#2D5F3E',
  },
  {
    id: 9,
    type: 'package_bought',
    title: 'Paket Satışı',
    description: 'Burak Tekin — 5 Seanslı SPA Paketi',
    time: '10:45',
    amount: '₺2.100',
    icon: 'ri-gift-line',
    iconBg: 'rgba(139,92,246,0.12)',
    iconColor: '#8B5CF6',
  },
  {
    id: 10,
    type: 'payment_transfer',
    title: 'Havale Tahsilat',
    description: 'Seda Arslan — Masaj Paketi ödemesi',
    time: '10:20',
    amount: '₺1.250',
    icon: 'ri-exchange-dollar-line',
    iconBg: 'rgba(59,130,246,0.12)',
    iconColor: '#3B82F6',
  },
];